export const interestCreditStyles = {
  gap: '10px',

  '& .inputs-container': {
    flexDirection: 'row',
    gap: 3,
    height: '90px',
  },

  '& .text-field-wrapper': {
    flex: 1,
    maxWidth: '340px',
  },

  '& .radio-group': {
    p: 0,
  },
};
